<template>
  <div class="p-2 text-left">
    <div class="row">
      <div class="col-12 mb-2">
        <b-input-group>
          <b-form-input
            v-model="search_text"
            placeholder="Search reflections..."
          ></b-form-input>
          <b-input-group-append>
            <b-button
              variant="outline-primary"
              class="m-0"
              @click="feelingsGet('search')"
            >
              <i class="fas fa-search"></i>
            </b-button>
            <b-button
              variant="outline-secondary"
              class="m-0"
              @click="feelingsGet('latest')"
            >
              <div v-if="history.length === 0" class="text-muted">
                <i class="fas fa-redo"></i>
              </div>
              <span v-else>
                <i class="fas fa-times"></i>
              </span>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>

      <div class="col-12 mb-3">
        <b-button block @click="addFeelings">
          <i class="fas fa-plus"></i> Reflection
        </b-button>

        <!-- <b-dropdown block right split>
					<template #button-content>
						<span block variant="outline-primary" @click="addFeelings">
							<i class="fas fa-pen"></i> Set My Intentions
						</span>
					</template>

					<b-dropdown-item @click="shareData">
						<i class="fas fa-share"></i> Share My Data
					</b-dropdown-item>
				</b-dropdown> -->
      </div>
    </div>

    <div v-if="searching == 1" class="text-muted text-center">
      <i class="fas fa-atom fa-spin"></i> searching
    </div>

    <div v-if="history !== null && history.length > 0" class="text-left">
      <div
        class="pointer mb-1"
        v-for="(feeling, index) in history"
        :key="'feeling-' + index"
        @click="viewFeeling(feeling)"
      >
        <div v-if="feeling.data.bars">
          <div class="row">
            <div class="col-12 gold small">
              <i
                v-if="feeling.has_new_comment == 1"
                class="fas fa-comment-dots fa-flip-horizontal fa-2x mr-2 text-danger"
              ></i>
              <span class="" v-text="feeling.date_human"> </span>
            </div>

            <div class="col-12">
              <div class="progress" style="height: 20px">
                <div
                  v-for="(value, id) in feeling.data.bars"
                  :key="'progress-' + id"
                  class="progress-bar border-bottom text-left border-right"
                  role="progressbar"
                  :aria-valuenow="value"
                  aria-valuemin="0"
                  aria-valuemax="10"
                  :style="setBarWidth(value, id, feeling.data.bars)"
                  :class="setBarColour(value)"
                >
                  <span v-if="value > 0" class="text-white pl-1">
                    <small v-text="id" class="pr-1"></small>
                    <b v-text="value"></b>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <add-feeling-log
      :modal_type="modal_type"
      :feeling="active_feeling"
      :feelings="feelings"
      :questions="questions"
      :readonly="readonly"
      @onAction="onAddFeelingAction"
      @onComment="onAddCommentAction"
      v-if="active_feeling"
    ></add-feeling-log>
  </div>
</template>

<script>
import axios from "@/axios";
import AddFeelingLog from "@/components/feelings/AddFeelingLog";
import {QUESTIONS, FEELINGS} from "@/components/feelings/data";

export default {
  name: "FeelingsLog",
  components: {
    AddFeelingLog,
  },
  props: {
    userid: {
      type: Number,
      default: null,
    },
    limit: {
      type: Number,
      default: 14,
    },
    readonly: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      active_feeling: null,
      addUserGoalMsg: "",
      modal_type: "add",
      search_text: "",
      searching: 1,
      history: [],
      feelings_total: 0,
      feelings: FEELINGS,
      goal: "",
      goal_latest: "",
      questions: QUESTIONS,
    };
  },
  beforeMount() {
    this.sanitiseQuestions();
  },
  mounted() {
    this.feelingsGet("latest");
    this.$root.$on('dailylog-saved', () => this.feelingsGet('lestest'))
  },
  beforeDestroy() {
    this.$root.$off('dailylog-saved')
  },
  computed: {
    date: {
      get: function() {
        /*
					toISOString returns a string in simplified extended ISO format (ISO 8601), which is always 24 or 27 characters long ( YYYY - MM - DD T HH : mm : ss. sss Z or ± YYYYYY - MM - DD T HH : mm : ss. sss Z , respectively). The timezone is always zero UTC offset, as denoted by the suffix " Z ".
				*/
        return new Date().toISOString().slice(0, 10);
      },
      set: function(val) {
      },
    },
  },
  methods: {
    sanitiseQuestions: function() {
      console.log(this.questions);
      for (let key in this.questions) {
        try {
          let obj = JSON.parse(this.questions[key]["value"]);
          this.questions[key]["sanitised_value"] = obj["text"];
        } catch (error) {
          this.questions[key]["sanitised_value"] = this.questions[key]["value"];
        }
      }
    },

    addFeelings() {
      this.modal_type = "add";
      this.addUserGoalMsg = "";
      let _this = this;

      this.active_feeling = {};

      // Set unfinished feelingsLog from LocalStorage
      const feelingsLog = localStorage.getItem("feelingsLog");
      if (feelingsLog !== null) {
        const log = JSON.parse(feelingsLog);
        for (let key in log["feelings"]) {
          this.feelings[key] = log["feelings"][key];
        }
        for (let key in log["questions"]) {
          this.questions[key] = log["questions"][key];
        }
      } else {
        // resets feelings and questions to empty and 0.
        const feelings = Object.values(this.feelings);
        for (const key of feelings) {
          if (this.feelings[key.id]) {
            this.feelings[key.id].value = 0;
          }
        }
        const questions = Object.values(this.questions);
        for (const key of questions) {
          if (key.id === "goal") {
            this.questions["goal"].value = _this.goal_latest;
            this.questions["goal"].sanitised_value = _this.goal_latest;
          } else {
            this.questions[key.id].value = "";
            this.questions[key.id].sanitised_value = "";
          }
        }
        // reset date and disable submit button
        this.date = "";
      }

      this.$nextTick(() => {
        this.$bvModal.show("feelings_wrapper");
      })
    },

    onAddFeelingAction() {
      this.$bvModal.hide("feelings_wrapper");
      this.active_feeling = null
      this.cancel()
      this.feelingsGet("latest");
    },

    onAddCommentAction() {
      this.feelingsGet("latest");
    },

    feelingsGet(type) {
      console.log("feelingsGet:");
      let _this = this;
      let params = new URLSearchParams();
      params.append("readonly", this.readonly);

      if (this.userid) {
        params.append("user_id", this.userid);
      }

      params.append("category", "user_feelings_log");

      params.append("limit", this.limit);
      params.append("order_by", "access");
      params.append("order_direction", "desc");
      params.append("type", "edit");

      if (type == "search") {
        params.append("search_text", _this.search_text);
      }

      this.history = [];
      this.search_text = "";
      this.searching = 1;

      axios({
        url: "feelingsGet",
        params: params,
      })
        .then(function(response) {
          const entries = Object.values(response.data.feelings || {})
          _this.history = entries;
          if (response.data.goal) {
            _this.goal_latest = response.data.goal;
          }

          _this.feelings_total = response.data.total_feelings;
          _this.searching = 0;

          _this.$store.commit("profileActiveSet", response.data.profile);

          if (_this.$route.params.id) {
            const match = entries.find(f => String(f.id) === _this.$route.params.id);
            if (match) {
              _this.$nextTick(() => _this.viewFeeling(match));
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    /*membersSearch(search, loading) {
			if (search.length) {
				loading(true);
				this.membersGet(loading, search, this);
			}
		},
		membersGet(loading, search) {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('search_term', search);
			params.append('type', 'team_members');
			axios({
				url: _this.$store.state.api_url + 'teamMembersSearch',
				params: params,
			})
				.then(function (response) {
					_this.share_members = Object.values(response.data.items);
					loading(false);
				})
				.catch(function () {
					console.log('Error: membersGet.');
				});
		},*/

    mark_feeling_viewed(feeling) {
      feeling.has_new_comment = 0;
      let _this = this;
      let params = new URLSearchParams();
      params.append("token", _this.$store.state.session_id);
      params.append("forum_id", feeling.id);

      axios({
        method: "post",
        url: _this.$store.state.api_url + "forumRepliesViewed",
        data: params,
      })
        .then(function() {})
        .catch(function(error) {
          console.log(error);
        });
    },

    ObjectLength(object) {
      return Object.keys(object).length;
    },

    setBarWidth(val, id, bars) {
      var num = this.ObjectLength(bars);
      val = (val / num) * 100;
      var C = "width: " + val + "%;";
      return C;
    },

    setBarColour(val) {
      var C = "white_bgd";
      if (val > 7) {
        C = "gold_bgd";
      } else if (val > 4) {
        C = "cl_bg_blue"; //'silver_bgd';
      } else if (val > 0) {
        C = "bronze_bgd";
      }
      return C;
    },

    shareData() {
      this.$bvModal.show("share_wrapper");
    },

    viewFeeling(feeling) {
      if (feeling.has_new_comment == 1) {
        this.mark_feeling_viewed(feeling);
      }
      this.active_feeling = feeling;
      this.modal_type = "edit";

      const feelings = Object.values(this.feelings);
      for (const key of feelings) {
        if (this.feelings[key.id]) {
          this.feelings[key.id].value = this.active_feeling.data.bars[key.id]
            ? this.active_feeling.data.bars[key.id]
            : 0;
        }
      }
      const questions = Object.values(this.questions);
      for (const key of questions) {
        if (this.questions[key.id]) {
          this.questions[key.id].value = this.active_feeling.data.questions[
            key.id
          ];
          this.questions[key.id].sanitised_value = ""; // overwrite sanitised_value back to ""
          /*if (key.id == 'goal') {
						this.goal = this.active_feeling.data.questions['goal'];
					}*/
        }
      }
      this.sanitiseQuestions();
      console.log(this.questions, "mounted");
      /* handle no goal set 
			if(this.active_feeling.data.questions['goal'] === undefined){
			this.goal = this.goal_latest;
			this.questions.goal.value = this.goal_latest;
			}*/

      this.date = this.active_feeling.date_edit;

      this.$nextTick(() => {
        this.$bvModal.show("feelings_wrapper");
      })

    },

    yesNoText(val) {
      if (val == 0) return "No";
      else return "Yes";
    },

    cancel() {
      console.log("cancel");
      for (let key in this.questions) {
        this.questions[key]["sanitised_value"] = "";
      }
    },
  },
}

</script>

<style scoped>

.gold_bar {
  background-color: #fff;
  color: #d1af60 !important;
  text-align: left;
}
.sleep_bar {
  background-color: #ccc;
}
.productivity_bar {
  background-color: #ccc;
}
.wellbeing_bar {
  background-color: #ccc;
}

.text-wrapper {
  word-wrap: break-word;
}
</style>
